function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import { useUIDSeed } from "react-uid";
import { twMerge } from "../../../utils";
import { NumberedInfoCard, Section, SectionHeader } from "../../molecules";
export function NumberedInfoCardsGrid(_param) {
    var cards = _param.cards, enableLines = _param.enableLines, className = _param.className, headerProps = _objectWithoutProperties(_param, [
        "cards",
        "enableLines",
        "className"
    ]);
    var seed = useUIDSeed();
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-9 md:mb-12"
    }, /*#__PURE__*/ React.createElement(SectionHeader, _extends({
        variant: "centered"
    }, headerProps))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-flow-row auto-rows-max gap-7 grid-cols-1 md:grid-cols-3 md:gap-y-12"
    }, cards.map(function(card, cardIndex) {
        return /*#__PURE__*/ React.createElement(NumberedInfoCard, _extends({
            key: seed(card)
        }, card, {
            className: twMerge(cardIndex % 4 === 0 && "md:col-start-1", cardIndex % 4 === 1 && "md:col-start-2", cardIndex % 4 === 2 && "md:col-start-2", cardIndex % 4 === 3 && "md:col-start-3")
        }));
    }))));
}

//# sourceMappingURL=NumberedInfoCardsGrid.js.map